import { render, staticRenderFns } from "./QueryProfile.vue?vue&type=template&id=48a89ec5&"
import script from "./QueryProfile.vue?vue&type=script&lang=js&"
export * from "./QueryProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports